import CartQuantitySelector from '../../components/cart/cart-quantity-selector';
import Page from '../page';
import PageHelper from '../../helpers/page-helper';

export default class OldReturnsCartPage extends Page {
  private sidebarInput: JQuery;
  private sidebarOrderRecipientId: JQuery;
  private sidebarOrderNumber: JQuery;
  private entryInput: JQuery;

  private submitForms: JQuery;
  private updateRowRequest?: JQuery.jqXHR;

  constructor(container) {
    super();

    this.sidebarInput = container.find('.js-sidebarInput');
    this.sidebarOrderNumber = container.find('.js-sidebarOrderNumber');
    this.sidebarOrderRecipientId = container.find('.js-sidebarOrderRecipientId');
    this.entryInput = container.find('.js-entryInput');
    this.submitForms = container.find('.js-submitFormControl');

    this.bindSidebarInputChange();
    this.bindEntryInputChange();
    this.bindInterceptSubmit();

    CartQuantitySelector.initAll();
  }

  private bindInterceptSubmit(): void {
    this.submitForms.on('submit', (e) => {
      if (this.updateRowRequest) {
        e.preventDefault();
        e.stopPropagation();
        // Order simulate will refresh the page
      }
    });
  }

  private bindSidebarInputChange(): void {
    this.sidebarInput.on('change', () => {
      const orderRecipientId = this.sidebarOrderRecipientId.val();
      const orderNumber = this.sidebarOrderNumber.val();
      const data = {
        orderRecipientId,
        orderNumber,
      };

      OldReturnsCartPage.updateSidebar(data);
    });
  }

  private bindEntryInputChange(): void {
    const inputHandler = (e) => {
      const rowWrapper = $(e.currentTarget).closest('tr');
      const triggerCartSimulate = $(e.currentTarget).hasClass('js-salesOrderText');
      const entryData = OldReturnsCartPage.gatherEntryData(rowWrapper);

      this.updateEntry(entryData, triggerCartSimulate).catch((error) => {
        const errorRow = $(`.js-errorRow[data-entry-number=${entryData.entryNumber as string}]`);
        errorRow
          .removeClass('d-none')
          .find('td')
          .html(error.responseText);
      });
    };

    this.entryInput.on('change', (e) => {
      inputHandler(e);
    });
  }

  static gatherEntryData(rowWrapper: JQuery): any {
    const entryNumber = rowWrapper.data('entry-number') as string;
    const entryRows = $(`tr[data-entry-number="${entryNumber}"]`);
    const returnReason = entryRows.find('.js-returnReason').val();
    const salesOrderText = entryRows.find('.js-salesOrderText').val();
    const referenceOrderNumber = entryRows.find('.js-originalOrderNumber').val();
    const referencePositionNumber = entryRows.find('.js-originalPosition').val();

    return {
      returnReason,
      salesOrderText,
      referenceOrderNumber,
      referencePositionNumber,
      entryNumber,
    };
  }

  private updateEntry(data, triggerCartSimulate): JQuery.jqXHR {

    PageHelper.showLoadingIndicator();

    this.updateRowRequest = $.ajax({
      url: `${window.ACC.config.encodedContextPath}/oldReturns/updateOldCartEntries`,
      method: 'POST',
      data,
    })
      .done(() => {
        if (triggerCartSimulate) {
          window.location.reload();
        }
      })
      .always(() => {
        if (!triggerCartSimulate) {
          PageHelper.clearLoadingIndicator();
        }
      });

    return this.updateRowRequest;
  }

  static updateSidebar(data): JQuery.jqXHR {
    return $.ajax({
      url: `${window.ACC.config.encodedContextPath}/oldReturns/sidebar`,
      method: 'POST',
      data,
    });
  }
}
